
import coupons from "../components/coupons/coupons"
import getCartNumMixin from "@/mixins/getCartNum"

export default {
  name: "CouponPage",
  components: {
    coupons
  },
  mixins: [getCartNumMixin],
  data() {
    return {}
  },
  mounted() {
    document.title = this.$t("pageTitle.coupons")
  }
}
